<template>
  <div class="cargo-ag-grid-assembly-editor">
    <!--件数-->
    <el-input v-if="params.field === QUANTITY_NOT_ASSEMBLY_LABEL.code" v-model.number="quantityNotAssembly" type="number" :precision="0" :min="0" @input="handleChange" />
    <span v-if="params.field === QUANTITY_NOT_ASSEMBLY_LABEL.code">{{ ColumnUtils.number3ColumnLabelFunc2(params.data.quantityAssembly) }} / {{ ColumnUtils.number3ColumnLabelFunc2(params.data.quantity) }}</span>
    <!--毛重-->
    <el-input v-if="params.field === WEIGHT_NOT_ASSEMBLY_LABEL.code" v-model.number="weightNotAssembly" type="number" :precision="0" :min="0" @input="handleChange" />
    <span v-if="params.field === WEIGHT_NOT_ASSEMBLY_LABEL.code">{{ ColumnUtils.number3ColumnLabelFunc2(params.data.weightAssembly) }} / {{ ColumnUtils.number3ColumnLabelFunc2(params.data.weight) }}</span>
    <!--体积-->
    <el-input v-if="params.field === CUBAGE_NOT_ASSEMBLY_LABEL.code" v-model.number="cubageNotAssembly" type="number" :precision="0" :min="0" @input="handleChange" />
    <span v-if="params.field === CUBAGE_NOT_ASSEMBLY_LABEL.code">{{ ColumnUtils.number3ColumnLabelFunc2(params.data.cubageAssembly) }} / {{ ColumnUtils.number3ColumnLabelFunc2(params.data.cubage) }}</span>
    <!--计费重量-->
    <el-input v-if="params.field === CHARGE_NOT_WEIGHT_ASSEMBLY_LABEL.code" v-model.number="chargeWeightNotAssembly" type="number" :precision="0" :min="0" @input="handleChange" />
    <span v-if="params.field === CHARGE_NOT_WEIGHT_ASSEMBLY_LABEL.code">{{ ColumnUtils.number3ColumnLabelFunc2(params.data.chargeWeightAssembly) }} / {{ ColumnUtils.number3ColumnLabelFunc2(params.data.chargeWeight) }}</span>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  CHARGE_NOT_WEIGHT_ASSEMBLY_LABEL,
  CUBAGE_NOT_ASSEMBLY_LABEL,
  QUANTITY_NOT_ASSEMBLY_LABEL,
  WEIGHT_NOT_ASSEMBLY_LABEL
} from '@/class/cargo/model/parameters/SystemConstants'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import ColumnUtils from '@/utils/ColumnUtils'

export default Vue.extend({
  name: 'CargoAgGridAssemblyEditor',
  components: {
    AutoNumberInput
  },
  data() {
    return {
      ColumnUtils,
      QUANTITY_NOT_ASSEMBLY_LABEL, WEIGHT_NOT_ASSEMBLY_LABEL,
      CUBAGE_NOT_ASSEMBLY_LABEL, CHARGE_NOT_WEIGHT_ASSEMBLY_LABEL,
      custom: null,
      valueChanged: null,
      quantityNotAssembly: 0,
      weightNotAssembly: 0,
      cubageNotAssembly: 0,
      chargeWeightNotAssembly: 0,
      sizeWidth: 0,
      sizeHeight: 0,
      sizeQuantity: 0
    }
  },
  created() {
    this.custom = this.params
    this.quantityNotAssembly = parseInt(this.custom.data.quantityNotAssembly)
    this.weightNotAssembly = parseInt(this.custom.data.weightNotAssembly)
    this.cubageNotAssembly = parseInt(this.custom.data.cubageNotAssembly)
    this.chargeWeightNotAssembly = parseInt(this.custom.data.chargeWeightNotAssembly)
    this.valueChanged = this.custom.valueChanged
  },
  methods: {
    handleChange() {
      this.custom.data.quantityNotAssembly = parseInt(this.quantityNotAssembly)
      this.custom.data.weightNotAssembly = parseInt(this.weightNotAssembly)
      this.custom.data.cubageNotAssembly = parseInt(this.cubageNotAssembly)
      this.custom.data.chargeWeightNotAssembly = parseInt(this.chargeWeightNotAssembly)
      this.valueChanged(this.custom)
    }
  }
})
</script>

<style lang="scss" scoped>
.cargo-ag-grid-assembly-editor {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding: 2px 10px;
  .el-input {
    height: 24px;
    line-height: 24px;
    /deep/ .el-input__inner {
      height: 24px;
      text-align: right;
    }
  }
  span {
    height: 24px;
    line-height: 30px;
    font-size: 18px;
  }
}
</style>
